export default __webpack_public_path__ + "static/media/banner198.e2b63c4f.webp";